'use strict';


app.factory('Drink', ['$rootScope', 'Venue', 'Helper', 
    function ($rootScope, Venue, Helper) {
        var service = {};

        service.venue_discount = Venue.getDiscount();

        /**
         * return price 
         * 
         * @param Object drink
         */
        service.getPrice = function (drink) {
            // in send drink flow we are using
            // only original_price parameter
            return Helper.roundNumber(drink.original_price, 2);
        };


        /**
         * return price from selected drink
         *
         * @return Number  price
         */
        service.getSelectedDrinkPrice = function () {
            var drink = $rootScope.globals.selectedDrink;
            var price;
            
            // first get price
            price = this.getPrice(drink);

            // check if drink has double option selected
            if( this.isDoubleDrinkOptionSelected() ){
                // double the price
                price = Helper.roundNumber(price*2, 2);
            }

            return Helper.roundNumber(price, 2);
        };


        /**
         * check if double drink option is selected
         * 
         * @return Boolean
         */
        service.isDoubleDrinkOptionSelected = function(){
            // check if drink is selected and if the drink option is selected
            if( $rootScope.globals.selectedDrink && $rootScope.globals.selectedDrink.drinkOptions ){

                var drink_option = $rootScope.globals.selectedDrink.drinkOptions;
                var double = false;

                // loop trough options and check
                // if in the array string "Double" is mentioned
                angular.forEach(drink_option.options, function(value) {
                    if(value.indexOf('Double') !== -1) double = true;
                });

                return double;
            }

            return false;
        }


        /**
         * get selected drink options from selected drink
         * 
         * @return Object
         */
        service.getSelectedDrinkOptions = function(){

            return $rootScope.globals.selectedDrink.drinkOptions || {};
        }


        /**
         * function that checks if the 
         * selected drink has options
         * 
         * @return Boolean
         */
        service.checkIfSelectedDrinkHasOptions = function(){

            var drinks_with_options     = ['Vodka', 'Gin', 'Rum', 'Whisky', 'Bourbon', 'Other Liquor'];
            var selected_drink_category = $rootScope.globals.selectedDrink.categoryString;

            if( drinks_with_options.indexOf( selected_drink_category ) !== -1 ) {
                return true;
            }

            return false;
        }


        /**
         * update selected drink price by
         * the price that we got from api
         */
        service.handlePriceChanged = function(price){
            $rootScope.globals.selectedDrink.original_price = price;
        }


        return service;
    }]);